<template>
  <VisionSidebar
    :class="[bem({'is-loading': shopifyStore.loading}), 'ignore-theme']"
    :visible="shopifyStore.open"
    :max-width="480"
    @close="handleClose"
  >
    <template #customTitle>
      <div :class="bem('title-wrapper')">
        <h3 :class="bem('title')">
          Your Bag <template v-if="!shopifyStore.getOptimisticCartCount">is Empty</template>
        </h3>
        <span
          v-if="shopifyStore.getOptimisticCartCount"
          :class="bem('cart-count')"
        >
          <span
            v-if="shopifyStore.loading || (shopifyStore.getOptimisticCartCount != shopifyStore.bundledCartItemsTotal)"
            :class="bem('cart-counter-loader')"
          />
          {{ shopifyStore.getOptimisticCartCount }}
        </span>
      </div>
    </template>
    <FadeTransition>
      <template v-if="shopifyStore.open">
        <div
          v-if="shopifyStore.getOptimisticCartCount"
          :class="bem('content')"
        >
          <CartSidebarItems />
          <CartSidebarCollateral />
        </div>
        <CartSidebarEmpty v-else />
      </template>
    </FadeTransition>
  </VisionSidebar>
</template>

<script setup lang="ts">
const bem = useBEM('CartSidebar')
const shopifyStore = useShopifyStore() as any
const pageStore = usePageStore()

function handleClose() {
  shopifyStore.toggleCart(false)
}

watch(() => shopifyStore.open, () => {
  pageStore.toggleBlockBodyScroll(shopifyStore.open)
})
</script>
<style lang="postcss">
.CartSidebar {
  --cart-title-height: 40px;
  --cart-inline-padding: 16px;
  --cart-content-height: calc(100dvh - var(--cart-title-height) - var(--sidebar-margin-top) - var(--mobile-toggle-height));

  @screen md {
    --cart-title-height: 56px;
  }

  @screen xs {
    --cart-inline-padding: 24px;
  }

  &--is-loading .CartSidebar__content{
    @apply pointer-events-none;
  }
}

.CartSidebar__content {
  @apply flex flex-col items-stretch justify-between
  h-[var(--cart-content-height)]
  max-h-[var(--cart-content-height)]
}

.CartSidebar__title-wrapper {
  @apply px-[var(--cart-inline-padding)] h-[var(--cart-title-height)] pt-2 bg-white w-full flex items-center;
}

.CartSidebar__title {
  @apply inline heading-3;
}

.CartSidebar__cart-count {
  @apply text-grey-500 ml-2
  before:content-['('] after:content-[')'] after:ml-1;
}
</style>